import { Form, FormItemProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppFormItemProps {}

const StyledFormItemWrapper = styled.div`
  .ant-form-item-row {
    /* You can add specific styles here */
  }

  .ant-form-item-label label {
    font-size: ${({ theme }) => theme.fonts.fontSizes.fontSize15}px;
  }
`;
const AppFormItem: React.FunctionComponent<
  IAppFormItemProps & FormItemProps
> = (props) => {
  // TOOLS
  // PROPS
  const { children, ...formItempProps } = props;

  // SELECTORS

  // VIEW
  return (
    <StyledFormItemWrapper>
      <Form.Item
        labelCol={{ span: 24 }} // make the label on top
        {...formItempProps}
      >
        {children}
      </Form.Item>
    </StyledFormItemWrapper>
  );
};

export default AppFormItem;
